import type { IFetchApiProps } from '~/portal/api'
import { FETCH_API_METHODS, fetchApi } from '~/portal/api'
import { STATE_STORE_KEYS } from '~/portal/types'

export type TExportTaskStatus = 'STARTED' | 'COMPLETED' | 'FAILED'

export interface IFetchApiStartExportFiles {
	token: IFetchApiProps['token']
	projectId: number
	checklistId: number
}

export interface IFetchApiGetExportTask {
	token: IFetchApiProps['token']
	projectId: number
	checklistId: number
	taskId: string
}

export interface IExportTaskResponse {
	id: number
	status: TExportTaskStatus
	file_url?: string
	created_at?: string
}

export const fetchApiStartExportFiles = async ({
	token,
	projectId,
	checklistId
}: IFetchApiStartExportFiles): Promise<{ task_id: string } | undefined> => {
	const response = await fetchApi({
		url: `/project/${projectId}/checklist/${checklistId}/export-files`,
		method: FETCH_API_METHODS.Post,
		token,
		pendingKey: STATE_STORE_KEYS.ChecklistInteractive
	})
	if (response?.data) return response.data as { task_id: string }
}

export const fetchApiGetExportTask = async ({
	token,
	projectId,
	checklistId,
	taskId
}: IFetchApiGetExportTask): Promise<IExportTaskResponse | undefined> => {
	const response = await fetchApi({
		url: `/project/${projectId}/checklist/${checklistId}/export-files/tasks/${taskId}`,
		method: FETCH_API_METHODS.Get,
		token,
		pendingKey: STATE_STORE_KEYS.ChecklistInteractive
	})
	if (response?.data) return response.data as IExportTaskResponse
}
